/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */
import {React, useEffect, useState} from 'react';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import MenuItem from '@material-ui/core/MenuItem';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import IconButton from "@material-ui/core/IconButton";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import '../../css/table/TableFilter.css'
import {FormHelperText, InputLabel} from "@material-ui/core";

/**
 * Represents Table Filter and Search component
 *
 * @prop filter      filter value
 * @prop searchId    search value
 * @prop setFilter   function to call on filter change
 * @prop setSearchId function to call on search change
 * @prop updateTable function to update table
 * @prop surveyId    surveyId value
 * @prop setSurveyId function to call on surveyId change
 */
export default function TableFilter(props) {

    // Used to determine if resetting
    const [reset, setReset] = useState(false);

    /**
     * Handles change in filter selection menu
     *
     * @param event from form
     */
    const handleFilterChange = (event) => {
        props.setFilter(event.target.value);
    };

    /**
     * Handles change on survey id menu
     *
     * @param event from form
     */
    const handleSurveyIdChange = (event) => {
        props.setSurveyId(event.target.value);
    }

    /**
     * Handles change in search bar
     *
     * @param event from input
     */
    const handleSearchChange = (event) => {
        props.setSearchId(event.target.value);
        
    }

    /**
     * Handles click on search button
     */
    const handleSearchClick = () => {
        props.updateTable();
    }

    /**
     * Handles click on reset button
     */
    const handleResetClick = () => {
        props.setSearchId("");
        props.setFilter("");

        setReset(true);
    }

    /**
     * Update table on filter or surveyId change
     */
    useEffect(() => {
        props.updateTable();
    }, [props.filter, props.surveyId])

    /**
     * Update table on reset
     */
    useEffect(() => {
        if (reset) {
            props.updateTable();

            setReset(false);
        }
    }, [reset]);  

    return (
        <div className='tableFilter-paper'>
            <div className='tableFilter-wrapper' >
                <FormGroup row className='tableFilter-surveyFormGroup'>
                    <FormControl variant="outlined" className='tableFilter-formControl'>
                        <InputLabel id="surveyId">Survey Id</InputLabel>
                        <Select
                            label={"surveyId"}
                            value={props.surveyId}
                            onChange={handleSurveyIdChange}
                        >
                            <MenuItem value={"sleep-concierge-v1"}>sleep-concierge-v1</MenuItem>
                            <MenuItem value={"subjective-feedback-v1"}>subjective-feedback-v1</MenuItem>
                            <MenuItem value={"sleep-sleep-quality-v1"}>sleep-quality-v1</MenuItem>
                            <MenuItem value={"mask-sense-v1"}>mask-sense-v1</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                <div className='tableFilter-searchWrapper'>
                    <div style={{height: '100%'}}>
                        <InputBase
                            placeholder="Search..."
                            value={props.searchId}
                            classes={{
                                root: 'tableFilter-inputWrapper',
                                input: 'tableFilter-input',
                            }}
                            inputProps={{ 'aria-label': 'search' }}
                            onChange={handleSearchChange}
                            
                        />
                    </div>
                </div>
                <IconButton
                    variant="outlined"
                    color="primary"
                    aria-label="edit"
                    onClick={handleSearchClick}
                >
                    <SearchIcon />
                </IconButton>
                <IconButton
                    variant="outlined"
                    color="secondary"
                    aria-label="edit"
                    onClick={handleResetClick}
                >
                    <HighlightOffIcon />
                </IconButton>
            </div>
        </div>
    )
}